export const IS_TOUCH = "ontouchstart" in window;

export const UI_VERSION = "1.7";

export const TRIGGER_PREFIX_ABOVE = ">";
export const TRIGGER_PREFIX_BELOW = "<";
